if (!customElements.get('email-popup')) {
  customElements.define('email-popup', class EmailPopup extends HTMLElement {
    constructor() {
      super();

      if (window.location.pathname === "/challenge") return;

      // --- Elements ---
      this.popup = this.querySelector(".email__popup--mdoal__content");
      this.closePopup = this.querySelectorAll(".email__popup--toggle, .email-popup-overlay");
      this.hidePopup = this.querySelector('.email__popup--hide');
      this.offerOpen = this.querySelector('.offerPopup-open'); // ✅ added safely here

      // --- Event listeners ---
      this.closePopup.forEach((item) => {
        item.addEventListener("click", this.close.bind(this));
      });
      this.hidePopup?.addEventListener("click", this.hide.bind(this));

      // ✅ Offer click handler
      if (this.offerOpen) {
        this.offerOpen.addEventListener("click", () => {
          console.log("check"); // ✅ fixed typo
          this.open(); // You can trigger popup opening here
        });
      }

      // --- Popup timing ---
      const lastShown = localStorage.getItem("emailPopupTimestamp");
      const now = Date.now();

      if (!lastShown || now - parseInt(lastShown) > 24 * 60 * 60 * 1000) {
        this.init();
      }

      // --- Shopify editor ---
      if (Shopify.designMode) {
        document.addEventListener("shopify:section:load", (event) =>
          editorShopifyEvent(event, this, () => this.open.bind(this))
        );
        document.addEventListener("shopify:section:select", (event) =>
          editorShopifyEvent(event, this, this.open.bind(this))
        );
        document.addEventListener("shopify:section:deselect", (event) =>
          editorShopifyEvent(event, this, this.close.bind(this))
        );
      }
    }

    // --- Methods ---
    init() {
      if (Shopify && Shopify.designMode) return;
      setTimeout(() => this.open(), parseInt(this.dataset.delay) * 1000);
    }

    open() {
      document.body.classList.add('email-popup-show');
      this.popup.classList.add('popup-open');
    }

    close() {
      this.popup.classList.add('popup-closing');
      setTimeout(() => {
        this.popup.classList.remove('popup-open', 'popup-closing');
      }, 500);
      localStorage.setItem("emailPopupTimestamp", Date.now().toString());
    }

    hide() {
      this.close();
    }
  });
}
